module.exports = __webpack_public_path__ + "static/media/shree-maruti.6088fe4b.svg";